module.exports = __webpack_public_path__ + "img/phone-white.020a183c.svg";